import { render, staticRenderFns } from "./Pengajuan.vue?vue&type=template&id=3683db0a&"
import script from "./Pengajuan.vue?vue&type=script&lang=js&"
export * from "./Pengajuan.vue?vue&type=script&lang=js&"
import style0 from "./Pengajuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports